function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29 27a2 2 0 01-2 2H5a2 2 0 01-2-2V14h26v13zM8 24h4v-2H8v2zm6 0h4v-2h-4v2zm6 0h4v-2h-4v2zM8 20h4v-2H8v2zm6 0h4v-2h-4v2zm6 0h4v-2h-4v2zM10 3v2h12V3h2v2h3a2 2 0 012 2v5H3V7a2 2 0 012-2h3V3h2z",
    fill: props.color
  }));
}

export default SvgIconCalendarRexFilled;